import React from "react";
import styles from "./Overview.module.scss";
import Prices from "../../Prices";
import TransportationComponent from "../../Transportation/Transportation";
import { screenStore } from "stores/ScreenStore";
import { useResultListContext } from "common/contexts/ResultListContext";
import { Review } from "common/types/search";

interface MonthlyPrice {
  name: string;
  currency_code: string;
  price: number;
  duration_metric: string;
}

interface Props {
  resources: string[];
  view: string;
  monthlyPrice?: MonthlyPrice[];
  transportation_links: any;
  country: string;
  description: string;
  reviews_full: Review[];
  header: string;
}

export const Overview: React.FC<Props> = ({
  resources = [],
  view = 'list',
  monthlyPrice = [],
  transportation_links = [],
  country = '',
  description = '',
  reviews_full = [],
  header = '',
}) => {
  const {isMobile} = screenStore;
  const { workspaceType } = useResultListContext();
  
  let overviewBlockHeight;

  if (description.length > 2000) {
    overviewBlockHeight = description.length / 3.6;
  } else {
    overviewBlockHeight = description.length / 3.2;
  }

  const additionalHeight = (header.length > 35 && reviews_full.length > 0) ? 43 : 0;

  overviewBlockHeight += additionalHeight;

  return (
    <>
      <Prices
        workspaceType={workspaceType}
        prices={monthlyPrice}
        resources={resources}
      />
      {view === "map" && isMobile ? null : (
        <>
          <TransportationComponent
            country={country}
            transportationLinks={transportation_links}
          />
          <div
            className={styles.spacer}
            style={{ height: Math.ceil(overviewBlockHeight) }}
          >
            <div dangerouslySetInnerHTML={{ __html: description }}></div>
          </div>
        </>
      )}
    </>
  );
};
